import React, {Component} from "react";
import {withNamespaces} from "react-i18next";

class DeviceTypeForm extends Component {

    state = {
        id: null,
        label: '',
        port: '',
        rabbitRoutingKey: '',
        communicationProtocol: '',
    };

    loading = true;

    componentDidMount() {
        const { data } = this.props;
        if(data) {
            this.setState({
                id: data.id,
                label: data.label,
                port: data.port,
                rabbitRoutingKey: data.rabbitRoutingKey,
                communicationProtocol: data.communicationProtocol,
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    handleOnChangeOption = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        })
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { submit } = this.props;
        submit(this.state);
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="label"
                            value={this.state.label}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('port')}</label>
                        <input
                            type="number"
                            className="form-control"
                            name="port"
                            value={this.state.port}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('rabbitRoutingKey')}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="rabbitRoutingKey"
                            value={this.state.rabbitRoutingKey || ''}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('communicationProtocol')}</label>
                        <select
                            className="form-control"
                            name="communicationProtocol"
                            value={this.state.communicationProtocol || ''}
                            onChange={this.handleOnChangeOption}
                            required
                        >
                            <option value="">Brak</option>
                            <option value="TCP">TCP</option>
                            <option value="UDP">UDP</option>
                        </select>
                    </div>

                    <div className="form-group float-right">
                        { this.state.id ? (
                            <button type="submit" className="btn btn-primary">
                                <i className="fas fa-edit"> </i> {t('save-changes')}
                            </button>
                        ) : (
                            <button type="submit" className="btn btn-success">
                                <i className="fas fa-edit"> </i> {t('create')}
                            </button>
                        )}
                    </div>

                </form>
            </div>
        )
    }
};
export default withNamespaces()(DeviceTypeForm);
